import React from 'react'

const Footer = () => {
    return (
        <div className='footer'>
            <div className="copyright p-5 text-center">
                <p>Copyright ©2021 All rights reserved by Dip Pal</p>
            </div>
        </div>
    )
}

export default Footer
